<template>
  <g>
    <template v-if="member.officeX != 0 && member.officeY != 0">
      <foreignObject :x="member.officeX - 8" :y="member.officeY - 8" :width="width" :height="height">
        <span class="close-button mdi mdi-close-circle" @click="outMember" v-if="member.bot_id"></span>
        <img @click="clickMember" :src="member.icon" class="img-icon" :class="{'img-icon-select':memberSelect}" v-if="member.icon" xmlns="http://www.w3.org/1999/xhtml"/>
        <img @click="clickMember" src="@/assets/template/robot.png" class="img-icon" xmlns="http://www.w3.org/1999/xhtml" v-else>
      </foreignObject>
    </template>
  </g>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Member',
  componentName: 'Member',
  props: ['member', 'site'],
  data () {
    return {
      width: 64,
      height: 64,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('chatbot', ['chatbots']),
    memberSelect () {
      if (this.site && this.site[2] == true) {
        if  ((this.member.officeX==this.site[0]) && (this.member.officeY==this.site[1])) {
          return true
        }
      } else {
          return false
      }
    }
  },
  methods: {
    clickMember () {
      if (this.member.bot_id) {
        const url = process.env.OWN_ENDPOINT + '/single/' + this.user.companyID + '/' + this.member.bot_id
        window.open(url)
      } else {
        this.$emit('showProfile')
      }
    },
    outMember () {
      let tempOfficeStatus = {
        type   : 'robot',
        id     : this.member.bot_id,
        officeX: 0,
        officeY: 0,
        room   : null
      }
      this.$store.dispatch('virtualOffice/setVirtualOfficeSV', tempOfficeStatus)
    }
  }
}
</script>

<style lang="scss" scoped>
.img-icon {
  width: 64px;
  height: 64px;
  border: solid 2px #d99;
  border-radius: 50%;
  background: white;
  cursor: pointer;
  object-fit: cover;
}
.close-button {
  position: absolute;
  top: -6px;
  right: -1px;
  color: white;
}
.img-icon-select {
  border: solid 2px red;
  -webkit-animation:blink 0.5s ease-in-out infinite alternate;
  -moz-animation:blink 0.5s ease-in-out infinite alternate;
  animation:blink 0.5s ease-in-out infinite alternate;
}
@-webkit-keyframes blink{
  0% {opacity:0;}
  100% {opacity:1;}
}
@-moz-keyframes blink{
  0% {opacity:0;}
  100% {opacity:1;}
}
@keyframes blink{
  0% {opacity:0;}
  100% {opacity:1;}
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/Member.vue